let env: Config | undefined;

export async function loadConfig() {
    if (import.meta.env.DEV) {
        const envBase = await import('../../env.json').then(
            (module) => module.default
        );
        // @ts-ignore - This file does not exist in Git
        const envLocal = await import('../../env.local.json').then(
            (module) => module.default
        );
        // @ts-ignore
        env = { ...envBase, ...envLocal };
    } else {
        const response = await fetch('/light/env/env.json');
        env = await response.json();
    }
}

export function getConfig(): EnvConfig {
    if (!env) {
        throw 'Could not get config file';
    }

    return {
        authority: env.AUTH_URL, //(string): The URL of the OIDC provider.
        authUrl: env.AUTH_URL + '/connect/authorize',
        logoutUrl: env.AUTH_URL + '/connect/endsession',
        client_id: env.IDENTITY_CLIENT_ID, //(string): Your client application's identifier as registered with the OIDC provider.
        redirect_uri: env.REDIRECT_URL, //The URI of your client application to receive a response from the OIDC provider.
        login: env.AUTH_URL + '/login',
        guestUserSupported: env.GUEST_USER_SUPPORTED === true,
        automaticSilentRenew: false, //(boolean, default: false): Flag to indicate if there should be an automatic attempt to renew the access token prior to its expiration.
        loadUserInfo: false, //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
        silent_redirect_uri: env.REDIRECT_URL, //(string): The URL for the page containing the code handling the silent renew.
        post_logout_redirect_uri: env.LOGOFF_REDIRECT_URL, // (string): The OIDC post-logout redirect URI.
        audience: 'https://example.com', //is there a way to specific the audience when making the jwt
        response_type: 'id_token token', //(string, default: 'id_token'): The type of response desired from the OIDC provider.
        scope: 'sds openid', //(string, default: 'openid'): The scope being requested from the OIDC provider.
        webAuthResponseType: 'id_token token',
        useCors: env.USE_CORS,
        bff_api_url: env.BFF_API_URL,
        web_product_info: env.WEB_PRODUCT_INFO_URL,
        ahu_design_url: env.AHUD_URL,
        websocket_url: env.WEBSOCKET_URL,
        Environment: env.Environment
    };
}

export type EnvConfig = {
    authority?: string;
    authUrl?: string;
    logoutUrl?: string;
    client_id?: string;
    redirect_uri?: string;
    login?: string;
    guestUserSupported?: boolean;
    automaticSilentRenew?: boolean;
    loadUserInfo?: boolean;
    silent_redirect_uri?: string;
    post_logout_redirect_uri?: string;
    audience?: string;
    response_type?: string;
    scope?: string;
    webAuthResponseType?: string;
    useCors?: boolean;
    bff_api_url?: string;
    web_product_info?: string;
    ahu_design_url?: string;
    websocket_url?: string;
    Environment?: string;
};

interface Config {
    IDENTITY_URL: string;
    WEBSOCKET_URL: string;
    Environment: string;
    URLS_LANGUAGE: string;
    AHU_URL: string;
    AHUD_FEATURE_API: string;
    GUEST_USER_SUPPORTED: boolean;
    AUTH_URL: string;
    IDENTITY_CLIENT_ID: string;
    REDIRECT_URL: string;
    LOGOFF_REDIRECT_URL: string;
    USE_CORS: boolean;
    BFF_API_URL: string;
    WEB_PRODUCT_INFO_URL: string;
    AHUD_URL: string;
}
